import PlanDetails from 'templates/PlanDetails';

export default PlanDetails;